import React, { Component } from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import ContentUtils from "../lib/ContentUtils";
import TypeUtils from "../lib/TypeUtils";

export default class Content extends Component {
  static contextTypes = {
    type: PropTypes.object
  };

  static propTypes = {
    content: PropTypes.object,
    displayFields: PropTypes.bool,
    sortable: PropTypes.bool,
    onClick: PropTypes.func
  };

  static defaultProps = {
    displayFields: false,
    sortable: false
  };

  getType() {
    return this.context.type || this.props.type;
  }

  renderParts(type) {
    const { content, displayFields } = this.props;
    const fields = TypeUtils.displayFields(type);

    return (displayFields ? fields : [fields[0]]).map(field => {
      const partDefinition = type.parts.find(part => part.name === field);
      return ContentUtils.renderPart(content, field, partDefinition);
    });
  }

  render() {
    const {
      content,
      onClick,
      sortable,
      isDragging,
      connectDragSource,
      connectDragPreview
    } = this.props;
    const type = this.getType();

    const canSort = sortable || TypeUtils.sortable(type);
    const activeState = cn("list-state", {
      active: content.active,
      inactive: !content.active
    });
    const parts = this.renderParts(type);

    const component = (
      <div className={cn("content-row", { placeholder: isDragging })}>
        <div className="content-item">
          {canSort &&
            connectDragSource &&
            connectDragSource(<div className="handle" />)}
          <div className="main-action" onClick={onClick}>
            <div className={activeState} />
            {parts.map((part, index) => (
              <div className="part" key={index}>
                {part}
              </div>
            ))}
          </div>
        </div>
        {this.props.children}
      </div>
    );

    return connectDragPreview ? connectDragPreview(component) : component;
  }
}



// WEBPACK FOOTER //
// ./app/components/Content.js